import lodash from 'lodash'
import Base from '../base.store'
import moment from 'moment'
import { filter } from '../../../../utils/search'
import { cacheTime } from '../../../../utils/constant'

const baseUrl = '/api/v1/master/amphurs'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listByProvince: {},
        cacheDate: {
            listByProvince: {}
        }
    }),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cacheFindAll(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const where = [
                { name: 'name', operator: 'like', value: searchQuery },
            ]
            const sort = [{ name: 'seq', type: 'ASC' }]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list, where, sort })
            }
            return context.dispatch('findAll', { criteria: { select: ['*'] } })
                .then(list => filter({ list, where, sort }))
        },
        cacheFindAllByProvince(context, { name, nameEn, provinceId }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.listByProvince[provinceId];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const where = [{ name: 'refProvince.id', operator: '=', value: provinceId }]
            if (name) {
                where.push({ name: 'name', operator: 'like', value: name })
            }
            if (nameEn) {
                where.push({ name: 'nameEn', operator: 'like', value: nameEn })
            }
            const sort = [{ name: 'seq', type: 'ASC' }]
            const list = context.state.listByProvince[provinceId] || []
            if (list.length > 0 && !force) {
                return filter({ list, where, sort })
            }
            return context.dispatch('findAllByProvince', { provinceId })
                .then(list => filter({ list, where, sort }))
        },
        findAllByProvince(context, { criteria, config, provinceId }) {
            criteria = lodash.merge({
                select: ['*', 'refProvince.*'],
                page: 0,
                size: 1000000,
                sort: [{ name: "seq", type: "ASC" }],
                where: [
                    { name: "isActive", type: "Boolean", operator: '=', value: true },
                    { name: "refProvince.id", type: 'UUID', operator: '=', value: provinceId }
                ],
            }, criteria)
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    context.commit('setListByProvinceResult', { provinceId, list })
                    return list
                });
        }
    },
    mutations: {
        ...base.mutations,
        setListByProvinceResult(state, { provinceId, list }) {
            state.listByProvince[provinceId] = list
            state.cacheDate.listByProvince[provinceId] = moment().add(cacheTime, 'ms')
        },
    },
}
